/* VINYLPAC: any artwork file a customer uploads (Josh 10/17: "All file types should be accepted on all pages and
   forms", "We need to add ai and psd for certain").

   The original file always ships untouched. This only names its type for the upload and draws a preview for the page:
   - PNG, JPG, WebP, GIF, SVG: the browser draws the file itself (no change from before).
   - PDF, and Illustrator .ai saved PDF-compatible (Illustrator's default): page 1 through pdf.js.
   - Photoshop .psd / .psb: the flattened image Photoshop stores in the file ("Maximize compatibility", its default),
     RGB, CMYK, grayscale or indexed, 8 or 16 bit.
   - Anything else the browser can open (Safari: TIFF, HEIC): drawn as an image.
   - Everything else (EPS, older PostScript .ai, ZIP, CDR…): a plain card with the file type and name.

   window.VPArtFiles = { ext, mime, isWebImage, needsOriginal, dataUrl, render, preview, card } */
(function () {
  'use strict';
  if (window.VPArtFiles) return;

  var WEB = { png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', webp: 'image/webp', gif: 'image/gif', svg: 'image/svg+xml' };
  var WEB_TYPES = { 'image/png': 1, 'image/jpeg': 1, 'image/webp': 1, 'image/gif': 1, 'image/svg+xml': 1 };
  var OTHER = {
    pdf: 'application/pdf', ai: 'application/postscript', eps: 'application/postscript', ps: 'application/postscript',
    psd: 'image/vnd.adobe.photoshop', psb: 'image/vnd.adobe.photoshop', tif: 'image/tiff', tiff: 'image/tiff',
    heic: 'image/heic', heif: 'image/heif', bmp: 'image/bmp', avif: 'image/avif', zip: 'application/zip'
  };
  var TYPE_RE = /^[a-z0-9][a-z0-9!#$&^_.+-]{0,126}\/[a-z0-9][a-z0-9!#$&^_.+-]{0,126}$/i;

  function nameOf(file) { return String(file && file.name || ''); }

  // 'logo.PSD' -> 'psd'; '' when the name has no usable extension.
  function ext(name) {
    var m = /\.([a-z0-9]{1,10})$/i.exec(String(name || '').trim());
    return m ? m[1].toLowerCase() : '';
  }

  // The type the upload is sent as: the extension decides (browsers name .ai/.psd differently), then the browser's type.
  function mime(file) {
    var e = ext(nameOf(file));
    if (WEB[e]) return WEB[e];
    if (OTHER[e]) return OTHER[e];
    var t = String(file && file.type || '').toLowerCase();
    return TYPE_RE.test(t) ? t : 'application/octet-stream';
  }

  // The browser draws it as it is, so it is its own preview (the pages' old PNG/JPG/SVG path).
  function isWebImage(file) { return !!WEB_TYPES[mime(file)]; }
  function needsOriginal(file) { return !isWebImage(file); }

  // FileReader's data URL with the type the upload is sent as (it guesses, or leaves it empty).
  function dataUrl(readerResult, file) {
    return String(readerResult || '').replace(/^data:[^,]*,/, 'data:' + mime(file) + ';base64,');
  }

  function canvasFor(w, h) {
    var c = document.createElement('canvas');
    c.width = Math.max(1, w); c.height = Math.max(1, h);
    return c;
  }

  function head(file, n) {
    return file.slice(0, n).arrayBuffer().then(function (buf) { return new Uint8Array(buf); });
  }

  function ascii(b, n) {
    var s = '';
    for (var i = 0; i < Math.min(n, b.length); i++) s += String.fromCharCode(b[i]);
    return s;
  }

  // Any pixel not fully opaque.
  function hasAlpha(c) {
    var data = c.getContext('2d').getImageData(0, 0, c.width, c.height).data;
    for (var i = 3; i < data.length; i += 4) if (data[i] < 255) return true;
    return false;
  }

  // ── PDF and PDF-compatible Illustrator ──────────────────────────────────────
  function pdfLib() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (!window.vpLazy) return Promise.reject(new Error('PDF preview is unavailable.'));
    return Promise.resolve(window.vpLazy('pdfjs')).then(function () {
      if (!window.pdfjsLib) throw new Error('PDF preview is unavailable.');
      return window.pdfjsLib;
    });
  }

  function renderPdf(file, maxPx) {
    return Promise.all([file.arrayBuffer(), pdfLib()]).then(function (got) {
      var pdfjs = got[1];
      pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
      return pdfjs.getDocument({ data: new Uint8Array(got[0]) }).promise;
    }).then(function (doc) {
      return doc.getPage(1).then(function (page) {
        var vp1 = page.getViewport({ scale: 1 });
        var vp = page.getViewport({ scale: maxPx / Math.max(vp1.width, vp1.height) });
        var c = canvasFor(Math.round(vp.width), Math.round(vp.height));
        return page.render({ canvasContext: c.getContext('2d'), viewport: vp, background: 'rgba(0,0,0,0)' }).promise.then(function () {
          try { doc.destroy(); } catch (e) {}
          return { canvas: c, kind: 'pdf', alpha: true, dpi: null, pageIn: { w: vp1.width / 72, h: vp1.height / 72 } };
        });
      });
    });
  }

  // ── Photoshop ───────────────────────────────────────────────────────────────
  // PackBits row -> out (clamped to the row).
  function unpack(src, i, end, out) {
    var o = 0, n = out.length;
    while (i < end && o < n) {
      var b = src[i++];
      if (b < 128) { var c = Math.min(b + 1, n - o, end - i); out.set(src.subarray(i, i + c), o); i += b + 1; o += c; }
      else if (b > 128) { var r = Math.min(257 - b, n - o); out.fill(src[i++], o, o + r); o += r; }
    }
    if (o < n) out.fill(0, o);
  }

  function psd(buf, maxPx) {
    var d = new DataView(buf), u = new Uint8Array(buf), n = u.length;
    if (n < 40 || d.getUint32(0) !== 0x38425053) return null;   // '8BPS'
    var ver = d.getUint16(4), big = ver === 2;
    if (ver !== 1 && ver !== 2) return null;
    var len = function (p) { return big ? d.getUint32(p) * 4294967296 + d.getUint32(p + 4) : d.getUint32(p); };
    var chans = d.getUint16(12), h = d.getUint32(14), w = d.getUint32(18), depth = d.getUint16(22), mode = d.getUint16(24);
    var base = { 1: 1, 2: 1, 3: 3, 4: 4, 8: 1 }[mode];   // gray, indexed, RGB, CMYK, duotone (stored as gray)
    if (!base || (depth !== 8 && depth !== 16) || chans < base || !w || !h) return null;
    var p = 26;
    var cmLen = d.getUint32(p), cm = p + 4;
    p = cm + cmLen;
    var palette = mode === 2 ? (cmLen >= 768 ? u.subarray(cm, cm + 768) : null) : null;
    if (mode === 2 && !palette) return null;
    // Image resources: 1005 = resolution, 1053 = alpha channel ids (0 marks transparency).
    var resEnd = p + 4 + d.getUint32(p), dpi = null, alphaId = false;
    p += 4;
    while (p + 12 <= resEnd && d.getUint32(p) === 0x3842494D) {   // '8BIM'
      var id = d.getUint16(p + 4), q = p + 6 + ((u[p + 6] + 2) & ~1), size = d.getUint32(q), at = q + 4;
      if (id === 1005 && size >= 16) {
        var unit = function (k) { return d.getUint16(k) === 2 ? 2.54 : 1; };   // 2 = pixels per cm
        dpi = [d.getUint32(at) / 65536 * unit(at + 4), d.getUint32(at + 8) / 65536 * unit(at + 12)];
      }
      if (id === 1053) for (var k = 0; k + 4 <= size; k += 4) if (d.getUint32(at + k) === 0) alphaId = true;
      p = at + size + (size & 1);
    }
    p = resEnd;
    // Layer and mask info: a negative layer count means the first extra channel is the flattened image's transparency.
    var lmLen = len(p), lm = p + (big ? 8 : 4), alpha = alphaId;
    if (lmLen >= (big ? 10 : 6) && len(lm) >= 2 && d.getInt16(lm + (big ? 8 : 4)) < 0) alpha = true;
    alpha = alpha && chans > base;
    p = lm + lmLen;
    if (p + 2 > n) return null;
    var comp = d.getUint16(p);
    p += 2;
    if (comp !== 0 && comp !== 1) return null;   // ZIP-compressed flattened data: very rare
    var bps = depth / 8, rowBytes = w * bps, need = base + (alpha ? 1 : 0);
    var rowAt, rowEnd;
    if (comp === 1) {
      var cw = big ? 4 : 2, table = p, start = new Float64Array(need * h + 1);
      start[0] = p + chans * h * cw;
      for (var r = 0; r < need * h; r++) start[r + 1] = start[r] + (cw === 2 ? d.getUint16(table + r * 2) : d.getUint32(table + r * 4));
      if (start[need * h] > n) return null;
      rowAt = function (c, y) { return start[c * h + y]; };
      rowEnd = function (c, y) { return start[c * h + y + 1]; };
    } else {
      if (p + need * h * rowBytes > n) return null;
      rowAt = function (c, y) { return p + (c * h + y) * rowBytes; };
      rowEnd = function (c, y) { return p + (c * h + y + 1) * rowBytes; };
    }
    // Sampled straight to preview size: only the rows the preview needs are unpacked.
    var s = Math.min(1, maxPx / Math.max(w, h)), ow = Math.max(1, Math.round(w * s)), oh = Math.max(1, Math.round(h * s));
    var sx = new Uint32Array(ow);
    for (var x = 0; x < ow; x++) sx[x] = Math.min(w - 1, Math.floor((x + 0.5) * w / ow)) * bps;   // 16 bit: high byte first
    var c2 = canvasFor(ow, oh), ctx = c2.getContext('2d'), img = ctx.createImageData(ow, oh), px = img.data;
    var row = new Uint8Array(rowBytes), planes = [];
    for (var c = 0; c < need; c++) planes.push(new Uint8Array(ow));
    for (var oy = 0; oy < oh; oy++) {
      var y = Math.min(h - 1, Math.floor((oy + 0.5) * h / oh));
      for (c = 0; c < need; c++) {
        if (comp === 1) unpack(u, rowAt(c, y), rowEnd(c, y), row);
        else row = u.subarray(rowAt(c, y), rowEnd(c, y));
        var plane = planes[c];
        for (x = 0; x < ow; x++) plane[x] = row[sx[x]];
      }
      if (comp === 0) row = new Uint8Array(rowBytes);
      var o = oy * ow * 4, a = alpha ? planes[base] : null;
      for (x = 0; x < ow; x++, o += 4) {
        if (mode === 3) { px[o] = planes[0][x]; px[o + 1] = planes[1][x]; px[o + 2] = planes[2][x]; }
        else if (mode === 4) {   // stored inverted: 255 = no ink
          var kk = planes[3][x];
          px[o] = planes[0][x] * kk / 255; px[o + 1] = planes[1][x] * kk / 255; px[o + 2] = planes[2][x] * kk / 255;
        } else if (mode === 2) { var ix = planes[0][x]; px[o] = palette[ix]; px[o + 1] = palette[256 + ix]; px[o + 2] = palette[512 + ix]; }
        else { px[o] = px[o + 1] = px[o + 2] = planes[0][x]; }
        px[o + 3] = a ? a[x] : 255;
      }
    }
    ctx.putImageData(img, 0, 0);
    var real = dpi && dpi[0] >= 30 && dpi[0] <= 9600 && dpi[1] >= 30 && dpi[1] <= 9600 ? dpi : null;
    return { canvas: c2, kind: 'psd', alpha: alpha, dpi: real, px: [w, h], scale: ow / w };
  }

  // ── anything else the browser opens ─────────────────────────────────────────
  function renderImage(file, maxPx) {
    return new Promise(function (resolve) {
      var url = URL.createObjectURL(file), img = new Image();
      var done = function (out) { URL.revokeObjectURL(url); resolve(out); };
      img.onload = function () {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h) return done(null);
        var s = Math.min(1, maxPx / Math.max(w, h)), c = canvasFor(Math.round(w * s), Math.round(h * s));
        try {
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          done({ canvas: c, kind: 'image', alpha: hasAlpha(c), dpi: null, px: [w, h], scale: c.width / w });
        } catch (e) { done(null); }
      };
      img.onerror = function () { done(null); };
      img.src = url;
    });
  }

  // render(file, maxPx) -> Promise<{ canvas, kind: 'pdf'|'psd'|'image', alpha, dpi, px?, scale?, pageIn? } | null>
  function render(file, maxPx) {
    maxPx = maxPx || 2400;
    if (!file || !file.size) return Promise.resolve(null);
    return head(file, 1024).then(function (b) {
      var top = ascii(b, 1024);
      if (top.indexOf('%PDF-') !== -1) return renderPdf(file, maxPx);
      if (top.slice(0, 4) === '8BPS') return file.arrayBuffer().then(function (buf) { return psd(buf, maxPx); });
      if (isWebImage(file) || /^image\//.test(mime(file))) return renderImage(file, maxPx);
      return null;
    }).catch(function () { return null; });
  }

  // A card for files the browser can't draw: the type in large letters and the file name.
  function card(name) {
    var c = canvasFor(600, 600), x = c.getContext('2d'), r = 44, a = 24, b = 576;
    x.beginPath();
    x.moveTo(a + r, a); x.arcTo(b, a, b, b, r); x.arcTo(b, b, a, b, r); x.arcTo(a, b, a, a, r); x.arcTo(a, a, b, a, r);
    x.closePath();
    x.fillStyle = '#ffffff'; x.fill();
    x.lineWidth = 6; x.strokeStyle = '#d6d6d6'; x.stroke();
    var font = 'Satoshi, "Helvetica Neue", Arial, sans-serif', label = (ext(name) || 'file').toUpperCase().slice(0, 5);
    var shown = String(name || 'Artwork file');
    if (shown.length > 28) shown = shown.slice(0, 18) + '\u2026' + shown.slice(-8);
    x.textAlign = 'center'; x.textBaseline = 'middle'; x.fillStyle = '#111111';
    x.font = '700 ' + (label.length > 3 ? 120 : 150) + 'px ' + font; x.fillText(label, 300, 260);
    x.font = '500 34px ' + font; x.fillText(shown, 300, 400);
    x.fillStyle = '#666666'; x.font = '400 28px ' + font; x.fillText('Original file attached', 300, 452);
    return c;
  }

  // preview(file, maxPx) -> Promise<PNG data URL>: the drawn file, or its card. Never rejects.
  function preview(file, maxPx) {
    return render(file, maxPx || 1600).then(function (out) {
      var c = out ? out.canvas : card(nameOf(file));
      var url = c.toDataURL('image/png');
      c.width = c.height = 0;
      return url;
    });
  }

  window.VPArtFiles = { ext: ext, mime: mime, isWebImage: isWebImage, needsOriginal: needsOriginal, dataUrl: dataUrl,
    render: render, preview: preview, card: card };
})();
